import { useState } from 'react'
import './form-challenge.scss'
// libraries
import sanitizeHtml from 'sanitize-html'
// content
import { useContentfulFormChallenge } from '../../../../hooks/contentful'
// components
import Button from '../../../atoms/button/button'
import InputTextarea from '../../../atoms/input-textarea/input-textarea'
import Loading from '../../../atoms/loading/loading'

const FormChallenge = props => {
	const { onComplete, data, itsDone = false, isLoading } = props

	// data
	const [isAnswer, setIsAnswer] = useState('')

	// content
	const { loading, preguntaRetos: contentFormData = false } = useContentfulFormChallenge()

	// actions
	const handleSetAnswer = newValue => {
		setIsAnswer(sanitizeHtml(newValue))
	}

	// actions
	const handleSubmit = () => {
		onComplete({
			challengeName: data.tituloGeneral || null,
			challengeDimension: data.dimension || null,
			challengeMoment: data.idReto,
			challengeQuestionText: isAnswer,
			idReto: data.idReto,
			clickCta: true,
			challengeFatherId: data.idFather || null,
			challengeId: data.idReto
		})
		setIsAnswer('')
	}
	if (itsDone) return null

	if (isLoading || loading) return <Loading small />

	if (!contentFormData) return null

	return (
		<div className='m-form-challenge container'>
			{contentFormData.tituloPrincipal && <h4>{contentFormData.tituloPrincipal}</h4>}

			{contentFormData.subtitulo && <h3 className='mb1'>{contentFormData.subtitulo}</h3>}
			{contentFormData.input && (
				<InputTextarea
					placeholder={contentFormData.input}
					change={e => handleSetAnswer(e.target.value)}
					max={200}
					min={4}
				/>
			)}
			{contentFormData.boton && (
				<Button
					uppercase
					title={contentFormData.boton}
					classes='pink mt1'
					disabled={!(isAnswer.length >= 4 && isAnswer.length <= 200)}
					onClick={() => handleSubmit()}
				/>
			)}
		</div>
	)
}

export default FormChallenge
